import React from "react";
import ModuleShowcasePage from "../../marketing/ModuleShowcasePage";

const AsapSkills = () => <ModuleShowcasePage moduleKey="skills" />;

export default AsapSkills;
